
<div class="m-grid__item m-grid__item--fluid m-wrapper">

  <ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
      <span class="chevron left"></span>
      <span class="chevron right"></span>
      <p style="font-weight: bold; font-size:2rem; color: white; position: absolute; white-space: nowrap; text-align: center; width: 100%; left: -8px; top: 120px;">{{loadingMessage}}</p> 
  </ngx-spinner>

  <!--MAIN-->
  <div class="m-content" *ngIf="form">
    <!--begin::Portlet-->
    <div class="m-portlet">

      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text">TRIVIA</h3>
            <span style="color: lightgray; vertical-align: middle; display: table-cell; text-align: right;" class="m-portlet__head-text" *ngIf="serviceId > 0">
              {{serviceId}}
            </span>
          </div>
        </div>
      </div>



      <!--begin::Form-->
      <form [formGroup]="form" class="m-form m-form--fit m-form--label-align-right">
        <div class="m-portlet__body">
          <div class="m-form__section m-form__section--first">
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label"> Game Title: </label>
              <div class="col-lg-6">
                <input type="text" class="form-control m-input" formControlName="gameTitle" />
                <app-validation-display
                  [control]="form.controls.gameTitle"
                  errorMessage="Please enter a valid name for this trivia game."
                ></app-validation-display>
              </div>
            </div>

            <div *ngIf="showServicePeriod" class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label"> Period: </label>
              <div class="col-lg-8">
                <app-service-period
                formControlName="period"
                [minDays]="30">
              </app-service-period>
              </div>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <div class="col-lg-3 col-form-label frame-container" style="display: flex; flex-direction: column;">
              <div style="display: flex;">
                <ng-template #brandingTooltip>
                  Upload a custom logo, sponsored image, or custom trivia graphic. <br /><br />
                  Pro-Tip: Doing a themed Light Show (e.g., Pink Night)? Come back anytime to change your Trivia Image!
                </ng-template>
                <img
                  src="../../assets/app/media/img/icons/info-icon.png"
                  placement="right"
                  class="tooltip-icon"
                  style="position: absolute; top: 10px; left: 10px;"
                  [tooltip]="brandingTooltip"
                />
                <span class="trivia-part-title">Branding
                  <span [hidden]="form.controls.imageUrl.value" class="required-asterisk text-danger">*</span>
                </span>
              </div>
              <app-iphone-frame imageUri="assets/app/media/img/misc/Sponsor-Template.png">
                <div class="sponsor-view-title-area" [class.empty]="!form.controls.imageUrl.value">
                  <div
                    *ngIf="form.controls.imageUrl.value"
                    class="delete-btn center-items"
                    (click)="removeImage()"
                  >
                    <span>+</span>
                  </div>
                  <input
                    type="file"
                    (change)="uploadPng($event.target.files[0])"
                    name="file-1[]"
                    id="file-1"
                    class="inputfile inputfile-4"
                    data-multiple-caption="{count} files selected"
                    accept="image/x-png"
                  />
                  <label for="file-1" class="upload-label">
                    <img *ngIf="!loadingPngFile && form.controls.imageUrl.value" [src]="form.controls.imageUrl.value" class="uploaded-img" />
                    <span *ngIf="!loadingPngFile && !form.controls.imageUrl.value" class="uploaded-img">Click to upload png file</span>
                    <ngx-loading [show]="loadingPngFile"></ngx-loading>
                  </label>
                </div>
              </app-iphone-frame>
              <app-validation-display
                  [control]="form.controls.imageUrl"
                  errorMessage="Please provide a valid PNG sponsor image. The image must be at least 300x300 pixels in size."
              ></app-validation-display>
            </div>
            <div class="col-lg-3 col-form-label frame-container">
              <div>
                <ng-template #questionTooltip>
                  Enter your Question and Answers in the designated fields. <br /><br />
                  Answers will appear in the order you enter them. <br /><br />
                  Designate the correct answer by clicking the radio button to the right of the question.
                </ng-template>
                <img
                  src="../../assets/app/media/img/icons/info-icon.png"
                  placement="right"
                  class="tooltip-icon"
                  style="position: absolute; top: 10px; left: 10px;"
                  [tooltip]="questionTooltip"
                />
                <span class="trivia-part-title">Question
                  <span [hidden]="form.controls.questions.controls[0].controls.question.value" class="required-asterisk text-danger">*</span>
                </span>
                <app-iphone-frame imageUri="assets/app/media/img/misc/Question-Template.png" [background]="form.controls.navBarColor.value">
                  <div
                    formArrayName="questions"
                    [style.display]="i != selectedQuestionIndex ?'none':'inherit'"
                    *ngFor="let x of form.controls.questions.controls; let i = index"
                    style="height: 100%; width: 100%; position: absolute;"
                  >
                    <div [formGroupName]="i" *ngIf="i == selectedQuestionIndex" style="height: 100%; width: 100%;">
                      <textarea
                        type="text"
                        class="question-title"
                        placeholder="Question Text Here"
                        formControlName="question"
                      >
                      </textarea>
                      <div class="answer-container-wrapper">
                        <div
                          class="answer-container answer-container1"
                          [style.background]="x.value.correctAnswer === 0 ? form.controls.selectedAnswerColor.value : 'white'"
                        >
                          <input type="text" placeholder="Answer 1" formControlName="answerOne" /> <input type="radio" [value]="0" formControlName="correctAnswer" />
                        </div>
                        <div
                          class="answer-container answer-container2"
                          [style.background]="x.value.correctAnswer === 1 ? form.controls.selectedAnswerColor.value : 'white'"
                        >
                          <input type="text" placeholder="Answer 2" formControlName="answerTwo" /> <input type="radio" [value]="1" formControlName="correctAnswer" />
                        </div>
                        <div
                          class="answer-container answer-container3"
                          [style.background]="x.value.correctAnswer === 2 ? form.controls.selectedAnswerColor.value : 'white'"
                        >
                          <input type="text" placeholder="Answer 3" formControlName="answerThree" /> <input type="radio" [value]="2" formControlName="correctAnswer" />
                        </div>
                        <div
                          class="answer-container answer-container4"
                          [style.background]="x.value.correctAnswer === 3 ? form.controls.selectedAnswerColor.value : 'white'"
                        >
                          <input type="text" placeholder="Answer 4" formControlName="answerFour" /> <input type="radio" [value]="3" formControlName="correctAnswer" />
                        </div>
                      </div>
                    </div>
                  </div>
                </app-iphone-frame>
                <app-validation-display
                  [control]="form.controls.questions.controls[0].controls.question"
                  errorMessage="The first question is required."
                >
                </app-validation-display>
                <div class="questions-count" *ngIf="form.controls.questions.value.length>0">Question {{ selectedQuestionIndex + 1 }} of {{ form.controls.questions.value.length }}</div>
                <div class="question-count" *ngIf="!form.controls.questions.value.length>0">No questions added yet!</div>
                <div class="buttons-block">
                  <button type="button" (click)="prevQuestion()" class="btn btn-success" [disabled]="form.controls.questions.value.length <= 1">&lt;</button>
                  <button type="button" (click)="newQuestion()" class="btn btn-success">New</button>
                  <button type="button" (click)="deleteQuestion()" class="btn btn-success" [disabled]="form.controls.questions.value.length <= 1">
                    Delete
                  </button>
                  <button type="button" (click)="nextQuestion()" class="btn btn-success" [disabled]="form.controls.questions.value.length <= 1">&gt;</button>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-form-label frame-container">
              <img
                src="../../assets/app/media/img/icons/info-icon.png"
                placement="right"
                class="tooltip-icon"
                style="position: absolute; top: 10px; left: 10px;"
                tooltip="Specify the message that your Trivia winners will see upon winning."
              />
              <span class="trivia-part-title">Winner Text
                <span [hidden]="form.controls.winnerText.value" class="required-asterisk text-danger">*</span>
              </span>
              <div class="d-flex flex-column">
                <app-iphone-frame imageUri="assets/app/media/img/misc/Result-template.png" [background]="form.controls.navBarColor.value">
                <textarea
                  type="text"
                  class="question-title"
                  placeholder="Congrats! You win a free beverage!"
                  formControlName="winnerText">
                </textarea>
                </app-iphone-frame>
                <app-validation-display
                  [control]="form.controls.winnerText"
                  errorMessage="Winner text must be between 1 and 150 characters long"
                ></app-validation-display>
              </div>
            </div>
            <div class="col-lg-3 col-form-label frame-container">
              <img
                src="../../assets/app/media/img/icons/info-icon.png"
                placement="right"
                class="tooltip-icon"
                style="position: absolute; top: 10px; left: 10px;"
                tooltip="Specify the message that your Trivia losers will see."
              />
              <span class="trivia-part-title">Loser text
                <span [hidden]="form.controls.loserText.value" class="required-asterisk text-danger">*</span>
              </span>
              <app-iphone-frame imageUri="assets/app/media/img/misc/Result-template.png" [background]="form.controls.navBarColor.value">
                <textarea
                  type="text"
                  class="question-title"
                  placeholder="Sorry, better luck next time! Enter your info below for a chance to win an awesome prize."
                  formControlName="loserText">
              </textarea>
              </app-iphone-frame>
              <app-validation-display
                [control]="form.controls.loserText"
                errorMessage="Loser text must be between 1 and 150 characters long"
              ></app-validation-display>
            </div>
            <div class="col-lg-2 col-form-label"></div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label">Selected Answer Color: </label>
            <div class="col-lg-2">
              <input
                formControlName="selectedAnswerColor"
                type="text"
                class="form-control m-input"
                placeholder="{{ form.controls.selectedAnswerColor.value }}"
                [colorPicker]="form.get('selectedAnswerColor').value"
                [cpDisableInput]="true"
                [cpPosition]="right"
                [cpAlphaChannel]="'disabled'"
                [value]="form.get('selectedAnswerColor').value"
                [style.background]="form.get('selectedAnswerColor').value"
                (colorPickerChange)="form.get('selectedAnswerColor').setValue($event)"
              />
              <app-validation-display [control]="form.controls.selectedAnswerColor" errorMessage="Please specify valid color"></app-validation-display>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label">Navigation Header Color: </label>
            <div class="col-lg-2">
              <input
                formControlName="navBarColor"
                type="text"
                [cpDisableInput]="true"
                class="form-control m-input"
                placeholder="{{ form.controls.navBarColor.value }}"
                [colorPicker]="form.get('navBarColor').value"
                [cpAlphaChannel]="'disabled'"
                [cpPosition]="right"
                [value]="form.get('navBarColor').value"
                [style.background]="form.get('navBarColor').value"
                (colorPickerChange)="form.get('navBarColor').setValue($event)"
              />
              <app-validation-display [control]="form.controls.navBarColor" errorMessage="Please specify valid color"></app-validation-display>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label"> Countdown Timer: </label>
            <div class="col-lg-2">
              <input
                type="number"
                class="form-control"
                (change)="timerChange()"
                value="{{
                form.get('segments.0.duration').value | number: '1.0-5'
                }}"
                (input)="
                      form
                        .get('segments.0.duration')
                        .setValue($event.target.value);
                      form.get('segments.0.duration').markAsDirty()
                    "/>
              <app-validation-display [control]="form.get('segments.0.duration')" errorMessage="Please specify a valid countdown time greater than 15 seconds and less than 10 minutes"></app-validation-display>
            </div>
          </div>
          <div class="form-group m-form__group row" style="padding-bottom: 0px;">
            <label class="col-lg-4 col-form-label"> Time to Answer: </label>
            <div class="col-lg-2">
              <input formControlName="timeToAnswer" type="text" class="form-control" />
              <img
                src="../../assets/app/media/img/icons/info-icon.png"
                class="tooltip-icon"
                style="float: right; position: relative; top: -30px; right: -30px;"
                tooltip="Designate the time players will have to answer each question (in seconds).You can input time between 1 to 60 seconds."
              />
              <app-validation-display [control]="form.controls.timeToAnswer" errorMessage="Please specify valid time to answer"></app-validation-display>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label"> Number of Winners: </label>
            <div class="col-lg-2">
              <input formControlName="numberOfWinners" type="text" class="form-control" />
              <app-validation-display [control]="form.controls.numberOfWinners" errorMessage="Please specify valid number of winners"></app-validation-display>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label"> Notification Emails: </label>
            <div class="col-lg-6">
              <div style="display:flex;align-items:center;">
                <ng-select
                  [addTag]="true"
                  [multiple]="true"
                  [hideSelected]="true"
                  formControlName="listOfEmails"
                  bindLabel="label"
                >
                </ng-select>
                <img
                  src="../../assets/app/media/img/icons/info-icon.png"
                  class="tooltip-icon"
                  tooltip="A list of all user data submitted, including a list of winners
                , will be emailed to this address immediately following the end of the game"
                />
              </div>
              <span
                class="m-form__help"
                style="color:red;"
                *ngIf="!form.controls.listOfEmails.valid && (form.controls.listOfEmails.dirty || form.controls.listOfEmails.touched)"
              >
                Please remove any invalid or duplicate emails.
              </span>
            </div>
          </div>
            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  End of Trivia Redirect:
                </label>
                <div class="col-lg-4">
                  <select
                    class="form-control m-input"
                    id="redirectType"
                    name="redirectType"
                    [(ngModel)]="redirectType"
                    [ngModelOptions]="{standalone: true}"
                    (change)=redirectChange($event)
                  >
                    <option value="-1">No Redirect</option>
                    <option value="0">Open Browser to URL</option>
                    <option value="1">Coupon</option>
                  </select>
                </div>
            </div>
            <div
              *ngIf="redirectType == 0"
              class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label">
              Winner URL:
            </label>
            <div class="col-lg-4">
              <input
                type="text"
                id="winnerUrl"
                class="form-control m-input"
                formControlName="winnerUrl"
                placeholder=""
                (blur)="validateUrl('winnerUrl')"
              />
              <app-validation-display
                *ngIf="!form.controls.winnerUrl.value"
                errorMessage="Required for the selected Redirect Type"
                [control]="form.controls.winnerUrl"
              > </app-validation-display>
              <app-validation-display
                *ngIf="form.controls.winnerUrl.value"
                errorMessage="Please enter a valid URL"
                [control]="form.controls.winnerUrl"
              > </app-validation-display>
            </div>
          </div>
          <div
            *ngIf="redirectType == 0"
            class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label">
              Loser URL:
            </label>
            <div class="col-lg-4">
              <input
                type="text"
                id="loserUrl"
                class="form-control m-input"
                formControlName="loserUrl"
                placeholder=""
                (blur)="validateUrl('loserUrl')"
              />
              <app-validation-display
                *ngIf="!form.controls.loserUrl.value"
                errorMessage="Required for the selected Redirect Type"
                [control]="form.controls.loserUrl"
              > </app-validation-display>
              <app-validation-display
                *ngIf="form.controls.loserUrl.value"
                errorMessage="Please enter a valid URL"
                [control]="form.controls.loserUrl"
              > </app-validation-display>
            </div>
          </div>
          <app-coupon-select *ngIf="redirectType == 1" [couponSelectLabel]="'Winner Coupon'" [(selectedCouponId)]="form.controls.winnerCouponId.value"></app-coupon-select>
          <app-coupon-select *ngIf="redirectType == 1" [couponSelectLabel]="'Loser Coupon'" [(selectedCouponId)]="form.controls.loserCouponId.value"></app-coupon-select>
          <div class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label">
              Customize Trivia Rules
            </label>
            <div class="col-lg-2 startdateinput">
              <label class="switch">
                <input
                  formControlName="showRules"
                  id="shouldNotifyUserCreated"
                  type="checkbox"
                  class="form-control"
                  style="display:none"
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
          <div *ngIf="form.controls.showRules.value">
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label"> Trivia Title: </label>
              <div class="col-lg-6">
                <input type="text" class="form-control m-input" formControlName="title" />
                <app-validation-display
                  [control]="form.controls.title"
                  errorMessage="Please enter a valid title for this trivia game."
                ></app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label"> Rule 1: </label>
              <div class="col-lg-6">
                <textarea type="text" class="form-control m-input" formControlName="rule1"></textarea>
                <app-validation-display
                  [control]="form.controls.rule1"
                  errorMessage="Please enter a valid rule for this trivia game."
                ></app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label"> Rule 2: </label>
              <div class="col-lg-6">
                <textarea type="text" class="form-control m-input" formControlName="rule2"></textarea>
                <app-validation-display
                  [control]="form.controls.rule2"
                  errorMessage="Please enter a valid rule for this trivia game."
                ></app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label"> Rule 3: </label>
              <div class="col-lg-6">
                <textarea type="text" class="form-control m-input" formControlName="rule3"></textarea>
                <app-validation-display
                  [control]="form.controls.rule3"
                  errorMessage="Please enter a valid rule for this trivia game."
                ></app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label"> "Starts in..." Prompt: </label>
              <div class="col-lg-6">
                <input type="text" class="form-control m-input" formControlName="startsInLabelText" />
                <app-validation-display
                  [control]="form.controls.startsInLabelText"
                  errorMessage="Please enter a valid prompt for this trivia game."
                ></app-validation-display>
              </div>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label">
              <ng-template #embedInMusicToolTip>
                You can add your selfie cam to the end of a pre-existing light
                show, or, if you'd like to include it in a song, simply click on
                "CUSTOM MP3" and select where you would like the selfie cam to
                take place within the track.
              </ng-template>
              <img
                src="../../assets/app/media/img/icons/info-icon.png"
                class="tooltip-icon"
                placement="top"
                [tooltip]="embedInMusicToolTip"
              />
              Embed in music:
            </label>
            <div class="col-lg-2 startdateinput">
              <label class="switch">
                <input
                  formControlName="embedMusic"
                  id="shouldNotifyUserCreated"
                  type="checkbox"
                  class="form-control"
                  style="display:none"
                  (change)="onEmbedMusicChanged()"
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
          <div [hidden]="!form.controls.embedMusic.value">
            <div class="form-group m-form__group row">
              <div class="col-lg-3 col-form-label"></div>
              <div class="col-lg-6 col-form-label">
                  <ngx-loading [show]="loadingMp3"></ngx-loading>
                  <div>
                    <input
                      type="file"
                      (change)="uploadMp3($event.target.files)"
                      name="upload-mp3-btn"
                      id="upload-mp3-btn"
                      class="inputfile inputfile-3"
                      accept=".mp3"
                    />
                    <label for="upload-mp3-btn" class="btn btn-success">
                      + Upload mp3
                    </label>
                    <span>{{ mp3FileName }}</span>
                    <app-validation-display
                      [control]="form.controls.embedMp3Url"
                    ></app-validation-display>
                  </div>
                  <div #main>
                    <label class="col-lg-4 col-form-label"></label>
                    <div>
                      <app-mp3-player [editorMode]="'SCREEN'" [main]="main" timeFactorMs="1000" [url]="form.controls.embedMp3Url.value" [segmentsFormArray]="form.get('segments')" [useForLightshowEditor]="false" >                        </app-mp3-player>
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <div *ngIf="hasSiteManagement && id > 0" class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label">
                Regenerate Audio on Update:
            </label>
            <div class="col-lg-6">
                <label class="switch">
                  <input
                    formControlName="regenerateAudio"
                    type="checkbox" class="form-control">
                  <span class="slider round"></span>
                </label>
            </div>
          </div>
          <div
            *ngIf="hasSiteManagement"
            class="form-group m-form__group row"
          >
            <label class="col-lg-4 col-form-label">
              Use Audible Triggers:
            </label>
            <div class="col-lg-6">
              <label class="switch">
                <input
                  formControlName="useAudible"
                  type="checkbox"
                  class="form-control"
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
          <div
              *ngIf="hasSiteManagement"
              class="form-group m-form__group row"
            >
            <label class="col-lg-4 col-form-label">
              Trigger Insertion Pattern:
            </label>
            <div class="col-lg-6">
              <input
                type="text"
                id="insertionPattern"
                autocomplete="false"
                class="form-control m-input"
                formControlName="insertionPattern"
                placeholder=""
              />
              <app-validation-display
                  errorMessage="Invalid insertion pattern list. ex 1, 2, 3"
                  [control]="form.controls.insertionPattern"
                ></app-validation-display>
            </div>
            </div>
        </div>
      </form>
      <div class="m-portlet__body" style="padding:0 30px 30px 30px">
        <div class="form-group m-form__group row">
          <label class="col-lg-4 col-form-label" style="text-align: right;">
            Coupon Code:
          </label>
          <div class="col-lg-1">
            <app-coupon-code [(ngModel)]="couponCode"></app-coupon-code>
          </div>
          <img *ngIf="couponValid && priceFetched" src="../../assets/app/media/img/icons/checked.svg" style="height: 100%; width:35px;" />
        </div>
      </div>
      <div class="col-lg-8">
        <app-validation-display
          [control]="form.controls.imageUrl"
          errorMessage="Please provide a valid PNG sponsor image"
        ></app-validation-display>
      </div>
    </div>
    <button [disabled]="loading || !form.controls.questions.value[0].question" (click)="checkout()" type="button" class="btn btn-primary">{{ id ? 'Update' : 'Create' }}</button>
    <button (click)="cancel()" type="button" class="btn btn-danger" style="margin-left: 15px;">Cancel</button>
    <button
        *ngIf="id > 0"
        (click)="viewResults(serviceId, id)"
        style="margin-bottom: 15px; margin-right: 30px; float: right"
        type="button"
        class="btn btn-success"
      > View Game Results </button>
      <app-network-sync (showSpinner)="setSpinnerState($event)" (spinnerMessage)="setLoadingMessage($event)" [serviceId]="serviceId" [displayCountdown]="true" [viewRef]="viewRef" [serviceName]="'Trivia'" [controllerPath]="'trivia'"></app-network-sync>
  </div>
</div>
